import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { SolutionsSection } from './components/SolutionsSection';
import { PricingSection } from './components/PricingSection';
import { PlatformSection } from './components/PlatformSection';
import { GpsHardwareSection } from './components/GpsHardwareSection';
import { ProcessSection } from './components/ProcessSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-bg" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <StatsBar data-id="element-4" />
        <SolutionsSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <PlatformSection data-id="element-7" />
        <GpsHardwareSection data-id="element-8" />
        <ProcessSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <ContactSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}